import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty } from 'lodash';
import {
  Alert,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip
} from '@mui/material';
import Annotations from '../../../api/Annotations/Annotations';
import TrackingAnnotations from '../../../api/TrackingAnnotations/TrackingAnnotations';
import Videos from '../../../api/Videos/Videos';
import methodPromise from '../../../modules/method-promise-wrapper';

const ImportTrackingAnnotationToVideo = props => {
  const { annotationList, isloaded, isPublicMap, trackingAnnotationList, videoList } = props;
  const [annotationSelected, setAnnotationSelected] = React.useState('');
  const [annotationVideo, setAnnotationVideo] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [videoSelected, setVideoSelected] = React.useState('');
  const [videoToSave, setVideoToSave] = React.useState('');

  const body = (
    <Box
      backgroundColor="white"
      width="60vw"
      height="60vh"
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      p={3}
      borderRadius="8px"
      boxShadow={3}
    >
      {isloaded === true && (
        <>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="80%"
            p={2}
          >
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-select-label">Video to filter annotations</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Video to filter annotations"
                size="small"
                value={videoSelected || ''}
                onChange={event => {
                  setVideoSelected(event.target.value);
                  const newAnnotations = annotationList
                    .filter(obj => obj.geoJSON.properties.video === event.target.value)
                    .filter(annotation =>
                      trackingAnnotationList.some(track => track.annotationId === annotation._id)
                    );
                  setAnnotationVideo(newAnnotations);
                }}
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {videoList.map(item => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {isEmpty(videoSelected) ? (
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="demo-select-label">All annotations</InputLabel>
                <Select
                  labelId="demo-select-label"
                  id="demo-select"
                  label="All annotations"
                  size="small"
                  value={annotationSelected || ''}
                  onChange={event => setAnnotationSelected(event.target.value)}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {annotationList.map(item => (
                    <MenuItem key={item._id} value={item._id}>
                      {item.geoJSON.properties.template.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <>
                {isEmpty(annotationVideo) ? (
                  <Alert severity="info"> This annotation has no associated tracking.</Alert>
                ) : (
                  <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="demo-select-label">Annotation</InputLabel>
                    <Select
                      labelId="demo-select-label"
                      id="demo-select"
                      label="Annotation"
                      size="small"
                      value={annotationSelected || ''}
                      onChange={event => setAnnotationSelected(event.target.value)}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {annotationVideo.map(item => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.geoJSON.properties.template.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </>
            )}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="demo-select-label">Video to save</InputLabel>
              <Select
                labelId="demo-select-label"
                id="demo-select"
                label="Video to save"
                size="small"
                value={videoToSave || ''}
                onChange={event => {
                  setVideoToSave(event.target.value);
                }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {videoList.map(item => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            px={2}
          >
            <Button
              variant="outlined"
              color="success"
              // sx={{
              //   color: '#2A3F90',
              //   backgroundColor: 'white',
              //   borderColor: '#2A3F90'
              // }}
              onClick={async () => {
                const newAnnotations = trackingAnnotationList.filter(
                  obj => obj.annotationId === annotationSelected
                );
                const updatedAnnotations = newAnnotations.map(({ _id, geoJSON, ...rest }) => ({
                  ...rest,
                  geoJSON: {
                    ...geoJSON,
                    properties: {
                      ...geoJSON.properties,
                      video: videoToSave
                    }
                  }
                }));
                if (isEmpty(updatedAnnotations) === true) {
                  Bert.alert('Esta anotación no tiene ningún registro de seguimiento.', 'info');
                } else {
                  await methodPromise('annotations.insertMany', updatedAnnotations, isPublicMap);
                  Bert.alert('Annotations successfully imported', 'success');
                  setAnnotationSelected('');
                  setAnnotationVideo([]);
                  setVideoSelected('');
                  setVideoToSave('');
                }
              }}
            >
              Import
            </Button>
            <Button
              variant="outlined"
              sx={{
                color: '#2A3F90',
                backgroundColor: 'white',
                borderColor: '#2A3F90'
              }}
              onClick={() => {
                setOpenModal(false);
                setAnnotationSelected('');
                setAnnotationVideo([]);
                setVideoSelected('');
                setVideoToSave('');
              }}
            >
              Close
            </Button>
          </Box>
        </>
      )}
    </Box>
  );

  return (
    <>
      <Tooltip title="Import annotation">
        <Button
          onClick={() => {
            setOpenModal(true);
          }}
        >
          Import tracking of annotations to video
        </Button>
      </Tooltip>
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {body}
      </Modal>
    </>
  );
};
export default withTracker(() => {
  const videosSub = Meteor.isClient && Meteor.subscribe('videos.maps');
  const videoList = Videos.find({ deleted: { $eq: 'no' } });
  const annotationSub = Meteor.subscribe('annotations.tracking');
  const annotationList = Annotations.find({ isTracking: { $exists: true, $eq: true } }).fetch();
  const trackingAnnotationSub = Meteor.subscribe('trackingAnnotations.all');
  const trackingAnnotationList = TrackingAnnotations.find({}).fetch();

  const isloaded =
    videosSub.ready() &&
    annotationSub.ready() &&
    trackingAnnotationSub.ready() &&
    videoList &&
    annotationList.length > 0 &&
    trackingAnnotationList.length > 0;

  return {
    annotationList,
    isloaded,
    trackingAnnotationList,
    videoList
  };
})(ImportTrackingAnnotationToVideo);

ImportTrackingAnnotationToVideo.defaultProps = {
  annotationList: [],
  isloaded: false,
  isPublicMap: false,
  trackingAnnotationList: [],
  videoList: []
};
ImportTrackingAnnotationToVideo.propTypes = {
  annotationList: PropTypes.array,
  isloaded: PropTypes.bool,
  isPublicMap: PropTypes.bool,
  trackingAnnotationList: PropTypes.array,
  videoList: PropTypes.array
};
